import type { FC } from 'react';

import { Button, Dialog, Sheet } from '@sravni/react-design-system';
import type { DialogProps } from '@sravni/react-design-system/lib/Dialog';
import { useIsMobile } from '@sravni/react-utils';

import styles from './styles.module.scss';

interface CurtainPopupProps extends DialogProps {
    title: string;
    buttonText?: string;
}

export const CurtainPopup: FC<CurtainPopupProps> = (props) => {
    const isMobile = useIsMobile();
    const { children, onClose, buttonText = 'Понятно', title, ...restProps } = props;

    const Component = isMobile ? Sheet : Dialog;

    return (
        <Component onClose={onClose} {...restProps} className={styles.root} closable={false}>
            <Component.Header title={title} />
            <Component.Content className={styles.container}>{children}</Component.Content>
            <div className={styles.footer}>
                <Button onClick={onClose} size={52} variant="primary" block>
                    {buttonText}
                </Button>
            </div>
        </Component>
    );
};
